const findWidgetName = (element) => {
	let widgetName =
		element?.closest?.('[data-widget-name]')?.dataset?.widgetName;

	if (element?.closest?.('#ws-vehicle-gallery-modal')) {
		widgetName = 'ws-vehicle-gallery';
	}

	return widgetName;
};

export default findWidgetName;
